import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import K_Element from "../templates/K_Element";
import { ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface ElementOptions extends ComponentOptions {
    bsc?: string;
    title?: string;
    label?: string;
    toolTip?: string;
    width?: number;
}

export class Element extends TemplateComponent {

    options: ElementOptions;

    constructor(options: ElementOptions) {
        super(K_Element, options);
    }

    preRender() {
        const options = this.options;

        options.title = options.label || "";
        options.toolTip = ll(options.toolTip);
    }

    create() {
        // There was a bug with the tooltip not going away on an editable table:
        // if (this.options.toolTip) {
        //     toolTip({
        //         selector: $("#" + this.id)
        //     });
        // }
    }

}
